import { render } from "./ExamRegisterPage.vue?vue&type=template&id=e7d09d54&scoped=true"
import script from "./ExamRegisterPage.vue?vue&type=script&lang=js"
export * from "./ExamRegisterPage.vue?vue&type=script&lang=js"

import "./ExamRegisterPage.vue?vue&type=style&index=0&id=e7d09d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d09d54"]])

export default __exports__